import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';
import { NgModel } from '@angular/forms';

declare const google: any;

@Directive({
    selector: '[appAddressLookahead]',
    providers: [NgModel],
    standalone: true
})
export class AddressLookaheadDirective {
	@Output() setAddress: EventEmitter<any> = new EventEmitter();

	modelValue: any;
	autocomplete: any;

	private _el: HTMLElement;

	constructor(
		el: ElementRef,
		private model: NgModel
	) {
		this._el = el.nativeElement;
		this.modelValue = this.model;
		const input = this._el;
		this.autocomplete = new google.maps.places.Autocomplete(input, {
			componentRestrictions: { country: 'us' }
		});
		google.maps.event.addListener(this.autocomplete, 'place_changed', () => {
			const place = this.autocomplete.getPlace();
			this.invokeEvent(place);
		});
	}

	@HostListener('input', ['$event']) onEvent($event) {}

	invokeEvent(place: Object) {
		this.setAddress.emit(place);
	}
}
